import { t } from "@travily/i18n";
import { ConfirmDialog } from "@ui/components/ConfirmDialog";

export interface DeleteConfirmDialogProps {
  /** Confirm button label. Defaults to "Confirm deletion" */
  confirmLabel?: string;
  /** Warning text explaining what will be deleted */
  description: string;
  /** Whether the dialog is open */
  isOpen: boolean;
  /** Whether the confirm action is in progress */
  isPending?: boolean;
  /** Called when the confirm button is pressed */
  onConfirm: () => void;
  /** Called when the dialog should close (close button, Escape) */
  onOpenChange: (isOpen: boolean) => void;
}

/**
 * Confirmation dialog for destructive delete actions: a danger-toned
 * `ConfirmDialog` with the delete illustration. On desktop: a compact card
 * with the illustration overflowing the top edge and a corner close button.
 * On mobile: a bottom sheet with an inline illustration. Use before any
 * irreversible deletion.
 */
export function DeleteConfirmDialog({
  confirmLabel = t("components.delete_confirmation_modal.confirm"),
  description,
  isOpen,
  isPending = false,
  onConfirm,
  onOpenChange,
}: DeleteConfirmDialogProps) {
  return (
    <ConfirmDialog
      confirmLabel={confirmLabel}
      description={description}
      illustration="delete-confirmation"
      isPending={isPending}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      isOpen={isOpen}
      title={confirmLabel}
      tone="danger"
    />
  );
}
